<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" md="4">
          <div class="sticky-md" style="top: 110px">
            <qr-maker />
            <v-card-actions class="justify-center">
              <div class="rowinfo">
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-download`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                  style="
                    padding: unset !important;
                    align-self: center !important;
                  "
                />
              </div>
            </v-card-actions>
          </div>
        </v-col>

        <v-col class="pa-8" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>ورود اطلاعات</p>
                  <div v-if="e6 === 1">
                    <v-switch v-model="qrType" disabled>
                      <template v-slot:label>
                        <span class="text-muted"> کیوآر داینامیک باشد</span>
                        <p class="text-danger ml-2 mb-0">به زودی</p>
                      </template>
                    </v-switch>
                  </div>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo" style="width: 100%">
                    <v-text-field
                      v-model="visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام کیوآر"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام کیوآر"
                      style="padding-top: 40px !important"
                    />
                  </div>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <qr-address-field
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      append-icon="mdi-web"
                      class="mt-0 pt-0"
                      dense
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"
                      outlined
                      persistent-hint
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dtUrl`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="آدرس پیشفرض"
                      style="padding-top: 40px !important"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion icon="phone" single title="شماره">
                <template v-slot:content>
                  <div class="row mx-auto">
                    <div class="col-md-8">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="data.phone"
                          append-icon="mdi-phone"
                          counter="10"
                          dense
                          hint="شماره موردنظر خودرا بدون 0 وارد کنید."
                          label="شماره"
                          maxLength="10"
                          outlined
                          placeholder="شماره موردنظر خودرا بدون 0 وارد کنید."
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-phone`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="شماره"
                          style="padding-top: 40px !important"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="rowinfo">
                        <v-autocomplete
                          v-model="data.flag"
                          :items="flags"
                          append-icon="mdi-flag"
                          dense
                          item-text="preCode"
                          item-value="preCode"
                          label="پیش شماره کشور:"
                          outlined
                        >
                          <template v-slot:item="{ props, item }">
                            <span class="text-lg bg-white">
                              {{ item.emoji }}
                            </span>
                            ( {{ item.preCode }}) {{ item.name }}
                          </template>
                        </v-autocomplete>
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-flag`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="پیش شماره کشور:"
                          style="padding-top: 40px !important"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </list-expansion>

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6 = 2"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step
              v-if="qrType"
              :complete="e6 > 2"
              class="px-0 px-md-4"
              step="2"
              >تنظیمات کیوآر</v-stepper-step
            >
            <v-stepper-content
              v-if="qrType"
              class="pr-1 mx-0 mr-md-7 px-md-4"
              step="2"
            >
              <qr-management :data="data" />
              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 1" />
                </div>

                <div class="col-md-6">
                  <!--              <next-btn :loading="loading" @click="setSettings"/>-->
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-step
              :complete="qrType ? e6 > 3 : e6 > 2"
              :step="qrType ? 3 : 2"
              class="px-0 px-md-4"
            >
              دیزاین کیوآر
            </v-stepper-step>
            <v-stepper-content
              :step="qrType ? 3 : 2"
              class="pr-1 mx-0 mr-md-7 px-md-4"
            >
              <!--          <qr-customize v-model="qrDesign"/>-->
              <qr-code-make
                ref="qrCanvas"
                v-model="qrDesign"
                :file.sync="qrSvgDataUrl"
                :link="data.link"
                @save="qrDesign = $event"
              />
              <div class="row mx-auto">
                <!--            <div class="col-md-6">-->
                <!--              <prev-btn :loading="loading" text="ویرایش" style="background: orange"-->
                <!--                        @click="goto(`qr/${createdId}/edit`)" v-if="finish"/>-->

                <!--&lt;!&ndash;              <prev-btn :loading="loading" @click="e6 = 2" v-else/>&ndash;&gt;-->
                <!--            </div>-->

                <div class="col-md-12">
                  <div class="rowinfo">
                    <v-btn
                      v-if="data.svg"
                      class="btn-download float-left"
                      @click="showDialog = true"
                    >
                      <v-icon>mdi-progress-download</v-icon>
                      {{ $t("download_qr") }}                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-data-svg`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label=" دانلود کیوآر"
                      style="padding-top: 40px !important"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: 'دانلود کیوآر' }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-download-Qr`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${data?.domain?.name||'qrland.in/'}${data.identifier}`"
              :visit-name="visitName"
              @close="showDialog = false"
              :qr_id="info.qrId"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrMaker from "./qrMaker.vue";
import QrAddressField from "../../../content/fragments/qrAddressField.vue";
import ListExpansion from "../../../content/fragments/listExpansion.vue";
import NextBtn from "../../../content/fragments/nextBtn.vue";
import QrManagement from "./qrManage/qrManagement.vue";
import PrevBtn from "../../../content/fragments/prevBtn.vue";
import QrCodeMake from "../qrCodeStyle/qrCodeMake.vue";
import { debounce } from "../../../../main";
import DownloadFileWithApi from "../downloadFileWithApi.vue";

export default {
  name: "qrCall",

  components: {
    DownloadFileWithApi,
    QrCodeMake,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrMaker,
  },

  data() {
    return {
      serviceName: "Qrland",
      componentName: "catDBusiness",
      helpData: [],

      flags: [
        { preCode: "+98", emoji: "🇮🇷", name: "Iran" },
        { preCode: "+376", emoji: "🇦🇩", name: "Andorra" },
        { preCode: "+971", emoji: "🇦🇪", name: "United Arab Emirates" },
        { preCode: "+93", emoji: "🇦🇫", name: "Afghanistan" },
        { preCode: "+1", emoji: "🇦🇬", name: "Antigua & Barbuda" },
        { preCode: "+1", emoji: "🇦🇮", name: "Anguilla" },
        { preCode: "+355", emoji: "🇦🇱", name: "Albania" },
        { preCode: "+374", emoji: "🇦🇲", name: "Armenia" },
        { preCode: "+672", emoji: "🇦🇶", name: "Antarctica" },
        { preCode: "+54", emoji: "🇦🇷", name: "Argentina" },
        { preCode: "+1684", emoji: "🇦🇸", name: "American Samoa" },
        { preCode: "+43", emoji: "🇦🇹", name: "Austria" },
        { preCode: "+61", emoji: "🇦🇺", name: "Australia" },
        { preCode: "+297", emoji: "🇦🇼", name: "Aruba" },
        { preCode: "+994", emoji: "🇦🇿", name: "Azerbaijan" },
        { preCode: "+1246", emoji: "🇧🇧", name: "Barbados" },
        { preCode: "+880", emoji: "🇧🇩", name: "Bangladesh" },
        { preCode: "+32", emoji: "🇧🇪", name: "Belgium" },
        { preCode: "+226", emoji: "🇧🇫", name: "Burkina Faso" },
        { preCode: "+359", emoji: "🇧🇬", name: "Bulgaria" },
        { preCode: "+973", emoji: "🇧🇭", name: "Bahrain" },
        { preCode: "+257", emoji: "🇧🇮", name: "Burundi" },
        { preCode: "+1441", emoji: "🇧🇲", name: "Bermuda" },
        { preCode: "+673", emoji: "🇧🇳", name: "Brunei" },
        { preCode: "+591", emoji: "🇧🇴", name: "Bolivia" },
        { preCode: "+55", emoji: "🇧🇷", name: "Brazil" },
        { preCode: "+1242", emoji: "🇧🇸", name: "Bahamas" },
        { preCode: "+975", emoji: "🇧🇹", name: "Bhutan" },
        { preCode: "+267", emoji: "🇧🇼", name: "Botswana" },
        { preCode: "+375", emoji: "🇧🇾", name: "Belarus" },
        { preCode: "+501", emoji: "🇧🇿", name: "Belize" },
        { preCode: "+1", emoji: "🇨🇦", name: "Canada" },
        { preCode: "+41", emoji: "🇨🇭", name: "Switzerland" },
        { preCode: "+682", emoji: "🇨🇰", name: "Cook Islands" },
        { preCode: "+56", emoji: "🇨🇱", name: "Chile" },
        { preCode: "+237", emoji: "🇨🇲", name: "Cameroon" },
        { preCode: "+86", emoji: "🇨🇳", name: "China" },
        { preCode: "+57", emoji: "🇨🇴", name: "Colombia" },
        { preCode: "+506", emoji: "🇨🇷", name: "Costa Rica" },
        { preCode: "+53", emoji: "🇨🇺", name: "Cuba" },
        { preCode: "+238", emoji: "🇨🇻", name: "Cape Verde" },
        { preCode: "+357", emoji: "🇨🇾", name: "Cyprus" },
        { preCode: "+49", emoji: "🇩🇪", name: "Germany" },
        { preCode: "+246", emoji: "🇩🇬", name: "Diego Garcia" },
        { preCode: "+253", emoji: "🇩🇯", name: "Djibouti" },
        { preCode: "+45", emoji: "🇩🇰", name: "Denmark" },
        { preCode: "+1767", emoji: "🇩🇲", name: "Dominica" },
        { preCode: "+1808", emoji: "🇩🇴", name: "Dominican Republic" },
        { preCode: "+213", emoji: "🇩🇿", name: "Algeria" },
        { preCode: "+593", emoji: "🇪🇨", name: "Ecuador" },
        { preCode: "+372", emoji: "🇪🇪", name: "Estonia" },
        { preCode: "+20", emoji: "🇪🇬", name: "Egypt" },
        { preCode: "+291", emoji: "🇪🇷", name: "Eritrea" },
        { preCode: "+34", emoji: "🇪🇸", name: "Spain" },
        { preCode: "+251", emoji: "🇪🇹", name: "Ethiopia" },
        { preCode: "+358", emoji: "🇫🇮", name: "Finland" },
        { preCode: "+679", emoji: "🇫🇯", name: "Fiji" },
        { preCode: "+500", emoji: "🇫🇰", name: "Falkland Islands" },
        { preCode: "+691", emoji: "🇫🇲", name: "Micronesia" },
        { preCode: "+298", emoji: "🇫🇴", name: "Faroe Islands" },
        { preCode: "+33", emoji: "🇫🇷", name: "France" },
        { preCode: "+241", emoji: "🇬🇦", name: "Gabon" },
        { preCode: "+44", emoji: "🇬🇧", name: "United Kingdom" },
        { preCode: "+1473", emoji: "🇬🇩", name: "Grenada" },
        { preCode: "+995", emoji: "🇬🇪", name: "Georgia" },
        { preCode: "+594", emoji: "🇬🇫", name: "French Guiana" },
        { preCode: "+233", emoji: "🇬🇭", name: "Ghana" },
        { preCode: "+350", emoji: "🇬🇮", name: "Gibraltar" },
        { preCode: "+299", emoji: "🇬🇱", name: "Greenland" },
        { preCode: "+220", emoji: "🇬🇲", name: "Gambia" },
        { preCode: "+224", emoji: "🇬🇳", name: "Guinea" },
        { preCode: "+590", emoji: "🇬🇵", name: "Guadeloupe" },
        { preCode: "+240", emoji: "🇬🇶", name: "Equatorial Guinea" },
        { preCode: "+30", emoji: "🇬🇷", name: "Greece" },
        { preCode: "+502", emoji: "🇬🇹", name: "Guatemala" },
        { preCode: "+1671", emoji: "🇬🇺", name: "Guam" },
        { preCode: "+592", emoji: "🇬🇾", name: "Guyana" },
        { preCode: "+504", emoji: "🇭🇳", name: "Honduras" },
        { preCode: "+385", emoji: "🇭🇷", name: "Croatia" },
        { preCode: "+509", emoji: "🇭🇹", name: "Haiti" },
        { preCode: "+36", emoji: "🇭🇺", name: "Hungary" },
        { preCode: "+62", emoji: "🇮🇩", name: "Indonesia" },
        { preCode: "+353", emoji: "🇮🇪", name: "Ireland" },
        { preCode: "+91", emoji: "🇮🇳", name: "India" },
        { preCode: "+964", emoji: "🇮🇶", name: "Iraq" },
        { preCode: "+354", emoji: "🇮🇸", name: "Iceland" },
        { preCode: "+39", emoji: "🇮🇹", name: "Italy" },
        { preCode: "+1876", emoji: "🇯🇲", name: "Jamaica" },
        { preCode: "+962", emoji: "🇯🇴", name: "Jordan" },
        { preCode: "+81", emoji: "🇯🇵", name: "Japan" },
        { preCode: "+254", emoji: "🇰🇪", name: "Kenya" },
        { preCode: "+996", emoji: "🇰🇬", name: "Kyrgyzstan" },
        { preCode: "+855", emoji: "🇰🇭", name: "Cambodia" },
        { preCode: "+686", emoji: "🇰🇮", name: "Kiribati" },
        { preCode: "+850", emoji: "🇰🇵", name: "North Korea" },
        { preCode: "+82", emoji: "🇰🇷", name: "South Korea" },
        { preCode: "+965", emoji: "🇰🇼", name: "Kuwait" },
        { preCode: "+1345", emoji: "🇰🇾", name: "Cayman Islands" },
        { preCode: "+7", emoji: "🇰🇿", name: "Kazakhstan" },
        { preCode: "+856", emoji: "🇱🇦", name: "Laos" },
        { preCode: "+961", emoji: "🇱🇧", name: "Lebanon" },
        { preCode: "+423", emoji: "🇱🇮", name: "Liechtenstein" },
        { preCode: "+94", emoji: "🇱🇰", name: "Sri Lanka" },
        { preCode: "+231", emoji: "🇱🇷", name: "Liberia" },
        { preCode: "+266", emoji: "🇱🇸", name: "Lesotho" },
        { preCode: "+370", emoji: "🇱🇹", name: "Lithuania" },
        { preCode: "+352", emoji: "🇱🇺", name: "Luxembourg" },
        { preCode: "+371", emoji: "🇱🇻", name: "Latvia" },
        { preCode: "+218", emoji: "🇱🇾", name: "Libya" },
        { preCode: "+212", emoji: "🇲🇦", name: "Morocco" },
        { preCode: "+377", emoji: "🇲🇨", name: "Monaco" },
        { preCode: "+373", emoji: "🇲🇩", name: "Moldova" },
        { preCode: "+261", emoji: "🇲🇬", name: "Madagascar" },
        { preCode: "+692", emoji: "🇲🇭", name: "Marshall Islands" },
        { preCode: "+223", emoji: "🇲🇱", name: "Mali" },
        { preCode: "+976", emoji: "🇲🇳", name: "Mongolia" },
        { preCode: "+596", emoji: "🇲🇶", name: "Martinique" },
        { preCode: "+222", emoji: "🇲🇷", name: "Mauritania" },
        { preCode: "+1664", emoji: "🇲🇸", name: "Montserrat" },
        { preCode: "+356", emoji: "🇲🇹", name: "Malta" },
        { preCode: "+230", emoji: "🇲🇺", name: "Mauritius" },
        { preCode: "+960", emoji: "🇲🇻", name: "Maldives" },
        { preCode: "+265", emoji: "🇲🇼", name: "Malawi" },
        { preCode: "+52", emoji: "🇲🇽", name: "Mexico" },
        { preCode: "+60", emoji: "🇲🇾", name: "Malaysia" },
        { preCode: "+258", emoji: "🇲🇿", name: "Mozambique" },
        { preCode: "+264", emoji: "🇳🇦", name: "Namibia" },
        { preCode: "+687", emoji: "🇳🇨", name: "New Caledonia" },
        { preCode: "+227", emoji: "🇳🇪", name: "Niger" },
        { preCode: "+6723", emoji: "🇳🇫", name: "Norfolk Island" },
        { preCode: "+243", emoji: "🇳🇬", name: "Nigeria" },
        { preCode: "+505", emoji: "🇳🇮", name: "Nicaragua" },
        { preCode: "+31", emoji: "🇳🇱", name: "Netherlands" },
        { preCode: "+47", emoji: "🇳🇴", name: "Norway" },
        { preCode: "+977", emoji: "🇳🇵", name: "Nepal" },
        { preCode: "+674", emoji: "🇳🇷", name: "Nauru" },
        { preCode: "+368", emoji: "🇳🇺", name: "Niue" },
        { preCode: "+64", emoji: "🇳🇿", name: "New Zealand" },
        { preCode: "+968", emoji: "🇴🇲", name: "Oman" },
        { preCode: "+507", emoji: "🇵🇦", name: "Panama" },
        { preCode: "+968", emoji: "🇵🇪", name: "Peru" },
        { preCode: "+689", emoji: "🇵🇫", name: "French Polynesia" },
        { preCode: "+675", emoji: "🇵🇬", name: "Papua New Guinea" },
        { preCode: "+63", emoji: "🇵🇭", name: "Philippines" },
        { preCode: "+92", emoji: "🇵🇰", name: "Pakistan" },
        { preCode: "+48", emoji: "🇵🇱", name: "Poland" },
        { preCode: "+1787", emoji: "🇵🇷", name: "Puerto Rico" },
        { preCode: "+351", emoji: "🇵🇹", name: "Portugal" },
        { preCode: "+680", emoji: "🇵🇼", name: "Palau" },
        { preCode: "+595", emoji: "🇵🇾", name: "Paraguay" },
        { preCode: "+974", emoji: "🇶🇦", name: "Qatar" },
        { preCode: "+262", emoji: "🇷🇪", name: "Réunion" },
        { preCode: "+40", emoji: "🇷🇴", name: "Romania" },
        { preCode: "+381", emoji: "🇷🇸", name: "Serbia" },
        { preCode: "+7", emoji: "🇷🇺", name: "Russia" },
        { preCode: "+250", emoji: "🇷🇼", name: "Rwanda" },
        { preCode: "+966", emoji: "🇸🇦", name: "Saudi Arabia" },
        { preCode: "+677", emoji: "🇸🇧", name: "Solomon Islands" },
        { preCode: "+248", emoji: "🇸🇨", name: "Seychelles" },
        { preCode: "+249", emoji: "🇸🇩", name: "Sudan" },
        { preCode: "+46", emoji: "🇸🇪", name: "Sweden" },
        { preCode: "+65", emoji: "🇸🇬", name: "Singapore" },
        { preCode: "+386", emoji: "🇸🇮", name: "Slovenia" },
        { preCode: "+421", emoji: "🇸🇰", name: "Slovakia" },
        { preCode: "+232", emoji: "🇸🇱", name: "Sierra Leone" },
        { preCode: "+378", emoji: "🇸🇲", name: "San Marino" },
        { preCode: "+221", emoji: "🇸🇳", name: "Senegal" },
        { preCode: "+252", emoji: "🇸🇴", name: "Somalia" },
        { preCode: "+597", emoji: "🇸🇷", name: "Suriname" },
        { preCode: "+963", emoji: "🇸🇾", name: "Syria" },
        { preCode: "+235", emoji: "🇹🇩", name: "Chad" },
        { preCode: "+228", emoji: "🇹🇬", name: "Togo" },
        { preCode: "+66", emoji: "🇹🇭", name: "Thailand" },
        { preCode: "+992", emoji: "🇹🇯", name: "Tajikistan" },
        { preCode: "+690", emoji: "🇹🇰", name: "Tokelau" },
        { preCode: "+993", emoji: "🇹🇲", name: "Turkmenistan" },
        { preCode: "+216", emoji: "🇹🇳", name: "Tunisia" },
        { preCode: "+676", emoji: "🇹🇴", name: "Tonga" },
        { preCode: "+90", emoji: "🇹🇷", name: "Turkey" },
        { preCode: "+688", emoji: "🇹🇻", name: "Tuvalu" },
        { preCode: "+886", emoji: "🇹🇼", name: "Taiwan" },
        { preCode: "+255", emoji: "🇹🇿", name: "Tanzania" },
        { preCode: "+380", emoji: "🇺🇦", name: "Ukraine" },
        { preCode: "+256", emoji: "🇺🇬", name: "Uganda" },
        { preCode: "+1", emoji: "🇺🇸", name: "United States" },
        { preCode: "+598", emoji: "🇺🇾", name: "Uruguay" },
        { preCode: "+998", emoji: "🇺🇿", name: "Uzbekistan" },
        { preCode: "+379", emoji: "🇻🇦", name: "Vatican City" },
        { preCode: "+58", emoji: "🇻🇪", name: "Venezuela" },
        { preCode: "+84", emoji: "🇻🇳", name: "Vietnam" },
        { preCode: "+678", emoji: "🇻🇺", name: "Vanuatu" },
        { preCode: "+967", emoji: "🇾🇪", name: "Yemen" },
        { preCode: "+262", emoji: "🇾🇹", name: "Mayotte" },
        { preCode: "+27", emoji: "🇿🇦", name: "South Africa" },
        { preCode: "+260", emoji: "🇿🇲", name: "Zambia" },
        { preCode: "+263", emoji: "🇿🇼", name: "Zimbabwe" },
      ],
      qrSvgDataUrl: "",
      qrType: false,
      showDialog: false,
      editable: false,
      createdId: "",
      loading: false,
      finish: false,
      dtUrl: null,
      e6: 1,
      visitName: "شماره",
      data: {
        phone: "9123456789",
        flag: "+98",
      },
      cons: { title: "دانلود کیوآر" },
      qrDesign: null,
    };
  },

  mounted() {
    this.updateQr();
  },

  watch: {
    computedPhone(val) {
      debounce(() => {
        this.updateQr();
      }, 500);
    },
  },

  computed: {
    computedPhone() {
      return (this.data.flag ?? "") + this.data.phone;
    },
  },

  methods: {
    updateQr() {
      setTimeout(() => {
        this.$refs.qrCanvas.appendCanvas(this.computedPhone);
      }, 500);
    },
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      if (regex.test(str) || without_regex.test(str)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
